import {call, put} from 'redux-saga/effects';
import {receiveNewsData} from "../actions/newsActions";
import {fetchNewsData} from "../api/fetchNewsData";

export default function* getNewsData(action) {
  try {
    const newsData = yield call(fetchNewsData);
    yield put(receiveNewsData(newsData));
  } catch (e) {
    console.log(e)
  }
}



// WEBPACK FOOTER //
// ./src/sagas/newsSaga.js